import { createElement, FC, SVGProps } from 'react';
import { IconName, icons } from './icons';

export type { IconName };

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'name' | 'ref'> {
  name: IconName;
  /** Pixels, or any CSS length (e.g. '100%' to fill a sized wrapper). */
  size?: number | string;
  /** Defaults to the text colour. */
  color?: string;
  /** Gives the icon a name for assistive technology; otherwise it's decorative. */
  label?: string;
}

/**
 * Hugeicons, stroke sharp (see icons.config.json and scripts/sync-icons.mjs).
 * Small icons get a slightly heavier stroke so they don't look faint.
 */
const Icon: FC<IconProps> = ({ name, size = 20, color, label, style, strokeWidth, ...svgProps }) => {
  const stroke = strokeWidth ?? (typeof size === 'number' && size <= 16 ? 1.75 : 1.5);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      color={color}
      style={{ flexShrink: 0, ...style }}
      {...svgProps}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
      focusable="false"
    >
      {icons[name].map(([tag, attrs], i) =>
        createElement(tag, { ...attrs, ...('strokeWidth' in attrs ? { strokeWidth: stroke } : {}), key: i })
      )}
    </svg>
  );
};

export default Icon;
